<template>
  <div class="m-paginate-primary">
    <p class="m-paginate-primary-quantity">
      {{ $t('mPaginatePrimary.messagesQuantity.showing') }}
      {{ $paginate.getLimInf() }}
      {{ $t('mPaginatePrimary.messagesQuantity.of') }}
      {{ $paginate.getTotalElements() }}
      {{ $t('mPaginatePrimary.messagesQuantity.results') }}
    </p>
    <ul
      v-show="$paginate.getTotalPages() > 1"
      class="m-paginate-primary-pages">
      <li v-if="$paginate.getCurrentPage() != 1">
        <a
          class="page-inactive"
          href="#"
          @click.prevent="$paginate.initial()"
        >
          {{ $t('mPaginatePrimary.messagesPages.first') }}
        </a>
      </li>
      <li v-if="$paginate.getCurrentPage() != 1">
        <a
          class="page-inactive"
          href="#"
          @click.prevent="$paginate.decrement()"
        >
          {{ $t('mPaginatePrimary.messagesPages.previous') }}
        </a>
      </li>
      <li
        v-for="page in $paginate.lengthPages()"
        :key="page"
      >
        <a
          :class="page === $paginate.getCurrentPage() ? 'page-active' : 'page-inactive'"
          href="#"
          @click.prevent="$paginate.setCurrentPage(page)"
        >
          {{ page }}
        </a>
      </li>
      <li v-if="$paginate.getCurrentPage() < $paginate.getTotalPages()">
        <a
          class="page-inactive"
          href="#"
          @click.prevent="$paginate.increment()"
        >
          {{ $t('mPaginatePrimary.messagesPages.following') }}
        </a>
      </li>
      <li v-if="$paginate.getCurrentPage() < $paginate.getTotalPages()">
        <a
          class="page-inactive"
          href="#"
          @click.prevent="$paginate.last()"
        >
          {{ $t('mPaginatePrimary.messagesPages.last') }}
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'MoleculePaginatePrimary'
}
</script>
